interface ViolationListProps {
  items: string[];
  bulletColor?: "red" | "blue" | "gray";
  className?: string;
}

export function ViolationList({
  items,
  bulletColor = "gray",
  className = "",
}: ViolationListProps) {
  const colors = {
    red: "text-red-600",
    blue: "text-blue-600",
    gray: "text-gray-600",
  };

  return (
    <ul className={`space-y-2 ${className}`}>
      {items.map((item, index) => (
        <li
          key={index}
          className="text-gray-700 flex items-start gap-2 text-sm sm:text-base"
        >
          <span className={`${colors[bulletColor]} mt-1 flex-shrink-0`}>•</span>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
